var React = require('react');

function ArrowDownInline (props) {
    return React.createElement("svg",props,[React.createElement("metadata",{"key":0},React.createElement("rdf:RDF",null,React.createElement("cc:Work",{},[React.createElement("dc:format",{"key":0},"image/svg+xml"),React.createElement("dc:type",{"key":1}),React.createElement("dc:title",{"key":2})]))),React.createElement("path",{"id":"arrow","d":"m1.129 1.129c2.3637 2.8387 4.9382 5.5977 7.5016 8.3623 2.6379-2.7368 5.0632-5.5513 7.5016-8.3623","fill":"none","stroke":"inherit","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.258","key":1})]);
}

ArrowDownInline.defaultProps = {"width":"17.261","height":"10.62","version":"1.1","viewBox":"0 0 17.261 10.62"};

module.exports = ArrowDownInline;

ArrowDownInline.default = ArrowDownInline;
